import { Box, Button, FormGroup, InputLabel, Modal } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLists } from "../../context/listContext";
import { deleteProductImage } from "../../api/products.api";
import { useAuth } from "../../context/authContext";
import { useState } from "react";
import { BeatLoader } from "react-spinners";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45rem",
  bgcolor: "white",
  // border: "2px solid #000",
  borderRadius: "25px",
  boxShadow: 24,
  p: 2,
  padding: "2rem",
};

export const ProductGallery = () => {
  const { imagesList, fetchImagesList } = useLists();
  const { config } = useAuth();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [selectedImage, setSelectedImage] = useState({
    image_file: "",
    image_name: "",
    image_id: "",
  });
  const location = useLocation();
  console.log(location?.state?.data);
  useEffect(() => {
    fetchImagesList(location?.state?.data?.product_id);
  }, [reload]);
  const deleteImage = async () => {
    setLoading(true);
    await deleteProductImage(
      {
        ...selectedImage,
      },
      config
    );
    setOpen(false);
    setLoading(false);
    setReload((prev) => !prev);
  };
  const navigate = useNavigate();
  console.log(imagesList);
  return (
    <div className="w-1/1 flex justify-center min-h-[70vh] flex-wrap items-center">
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title2"
        aria-describedby="modal-modal-description2"
      >
        <Box sx={style}>
          {loading ? (
            <div className="items-center">
              <BeatLoader color="#36d7b7" />
            </div>
          ) : (
            <FormGroup>
              <InputLabel className="text-center" id="demo-simple-select-label">
                Are you sure you want to delete this image?
              </InputLabel>
              <img
                src={selectedImage?.image_file}
                alt={selectedImage?.image_name}
              />
              <div className="flex w-[100%] justify-between">
                <Button
                  className="w-[30%]"
                  onClick={deleteImage}
                  // onClick={() => deleteImage(img?.image_name, img?.image_id)}
                >
                  Yes
                </Button>
                <Button className="w-[30%]" onClick={() => setOpen(false)}>
                  No
                </Button>
              </div>
            </FormGroup>
          )}
        </Box>
      </Modal>
      <div className="w-[80%] flex-wrap flex border-black border-2 p-8">
        {imagesList?.map((img) => {
          return (
            <div className="w-[23.5%] mr-[1.5%] relative mt-4 shadow-xl">
              <span
                className="absolute flex cursor-pointer rounded-xl justify-center items-center bg-[red] w-6 h-6 pb-1 text-[white] right-0"
                onClick={() => {
                  setSelectedImage((prev) => ({
                    ...prev,
                    image_file: img?.image_file,
                    image_name: img?.image_name,
                    image_id: img?.image_id,
                  }));
                  setOpen(true);
                }}
                // onClick={() => deleteImage(img?.image_name, img?.image_id)}
              >
                x
              </span>
              <img
                className="w-[100%]"
                src={img?.image_file}
                alt={img?.image_name}
              />
            </div>
          );
        })}
      </div>
      <Button
        className="w-[30%]"
        variant="contained"
        onClick={() => {
          navigate("/add-product-image", {
            state: {
              data: location?.state?.data,
            },
          });
        }}
      >
        Add
      </Button>
    </div>
  );
};

// export default ProductGallery
